import React, { forwardRef } from 'react';
import { AnimatePresence } from 'framer-motion';
import { createPortal } from 'react-dom';
import { SideModalOverlay, SideModalContainer } from './SideModal.styles.js';
import { theme } from '@citygross/design-tokens';
var SideModal = forwardRef(function (_a, ref) {
  var _b, _c;

  var onBackdropClick = _a.onBackdropClick,
      _d = _a.background,
      background = _d === void 0 ? '#fff' : _d,
      _e = _a.overlayBackground,
      overlayBackground = _e === void 0 ? (_c = (_b = theme.palette) === null || _b === void 0 ? void 0 : _b.darkOverlay) !== null && _c !== void 0 ? _c : '' : _e,
      _f = _a.width,
      width = _f === void 0 ? 375 : _f,
      isVisible = _a.isVisible,
      slideFrom = _a.slideFrom,
      _g = _a.querySelector,
      querySelector = _g === void 0 ? '#root' : _g,
      maxWidth = _a.maxWidth,
      maxHeight = _a.maxHeight,
      children = _a.children;
  var domSafe = typeof document !== 'undefined';
  return domSafe ? createPortal(React.createElement(AnimatePresence, null, isVisible && React.createElement(SideModalOverlay, {
    ref: ref,
    onMouseDown: function onMouseDown(e) {
      if (e.target === e.currentTarget) {
        onBackdropClick();
      }
    },
    overlayBackground: overlayBackground,
    initial: {
      opacity: 0
    },
    maxHeight: maxHeight,
    animate: {
      opacity: 1
    },
    exit: {
      opacity: 0
    },
    transition: {
      type: 'just'
    }
  }, React.createElement(SideModalContainer, {
    slideFrom: slideFrom,
    maxHeight: maxHeight,
    maxWidth: maxWidth,
    transition: {
      type: 'just'
    },
    width: width,
    onClick: function onClick(e) {
      return e.stopPropagation();
    },
    background: background,
    initial: {
      x: slideFrom === 'left' ? '-100%' : '100%'
    },
    animate: {
      x: 0
    },
    exit: {
      x: slideFrom === 'left' ? '-100%' : '100%'
    }
  }, children))), document.querySelector(querySelector) || document.body) : null;
});
SideModal.displayName = 'SideModal';
export { SideModal, SideModal as default };